export default __webpack_public_path__ + "static/media/checkImg.58706ac3.svg";